import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { AppShell } from '@/components/layout/AppShell';
import { Toaster } from '@/components/ui/toaster';
import { MatchesPage } from '@/pages/MatchesPage';
import { NewMatchPage } from '@/pages/NewMatchPage';
import { ActiveMatchPage } from '@/pages/ActiveMatchPage';
import { MatchPage } from '@/pages/MatchPage';
import { PlayersPage } from '@/pages/PlayersPage';
import { TeamsPage } from '@/pages/TeamsPage';
import { ResultsPage } from '@/pages/ResultsPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { PWAProvider, usePWA } from '@/contexts/PWAContext';
import { initDB } from '@/db';

function UpdateBanner() {
  const { needRefresh, updateServiceWorker, dismissUpdate } = usePWA();

  if (!needRefresh) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 bg-primary text-primary-foreground p-4 rounded-lg shadow-lg z-50">
      <p className="text-sm mb-2">New version available!</p>
      <div className="flex gap-2">
        <button
          onClick={() => updateServiceWorker(true)}
          className="px-4 py-2 bg-white text-primary rounded text-sm font-medium"
        >
          Update
        </button>
        <button onClick={dismissUpdate} className="px-4 py-2 text-sm">
          Later
        </button>
      </div>
    </div>
  );
}

function AppContent() {
  // Initialize IndexedDB on app load
  useEffect(() => {
    initDB().catch(console.error);
  }, []);

  return (
    <>
      <AppShell>
        <Routes>
          <Route path="/" element={<Navigate to="/matches" replace />} />
          <Route path="/matches" element={<MatchesPage />} />
          <Route path="/matches/new" element={<NewMatchPage />} />
          <Route path="/matches/active/:matchId" element={<ActiveMatchPage />} />
          <Route path="/matches/:matchId" element={<MatchPage />} />
          <Route path="/players" element={<PlayersPage />} />
          <Route path="/teams" element={<TeamsPage />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Routes>
      </AppShell>

      <UpdateBanner />
      <Toaster />
    </>
  );
}

function App() {
  return (
    <PWAProvider>
      <AppContent />
    </PWAProvider>
  );
}

export default App;
